import { prop, propObject, required } from "@rxweb/reactive-form-validators";
import { Resource } from "src/app/core/jsonapi/resource";
import { TransactionType } from "./transaction-type";

export class TransactionRevisionReason extends Resource {
    public override type = 'transactionRevisionReasons';    
    
    @prop()
    @required()
    public name!: string;
    
    @prop()
    public active: boolean = true;

}